import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ContactSupport } from 'src/app/utils/interfaces/new/contact-support.interface';
import { Referentiel } from 'src/app/utils/interfaces/new/referentiel.interface';
import { TexteModele } from 'src/app/utils/interfaces/new/TexteModele';
import { environment } from 'src/environments/environment';
import { SnackbarService } from '../snackbar/snackbar.service';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  private httpOptions = {
    withCredentials: true,
    observe: 'response' as 'response',
    headers: new HttpHeaders()
  };

  private apiUri = environment.basePath + '/contact/';

  constructor(
    private _http: HttpClient,
    private _snack: SnackbarService
  ) { }

  async send(content: ContactSupport): Promise<void> {
    try {
      const res = await this._http.post(this.apiUri + "send", content, this.httpOptions).toPromise();
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }
}
